import instance from "@/services/api";

export const invalidObjectsAPI = {
  async read() {
    return await instance(true, null, { showToast: false, throwError: true })
      .get("/common/invalid_objects/")
      .then((res) => res?.data);
  },
  async readTableForForeignKey() {
    return await instance(true, null, { showToast: false, throwError: true })
      .get("/common/table_for_create_foreign_key/")
      .then((res) => res?.data);
  },
  async readTableForTrigger() {
    return await instance(true, null, { showToast: false, throwError: true })
      .get("/common/table_for_create_trigger/")
      .then((res) => res?.data);
  },
  async readFuncStat(func_name = "") {
    return await instance(true, null, { showToast: false, throwError: true })
      .get("/common/func_stat/", { params: { func_name } })
      .then((res) => res?.data);
  },
};

